import {
    adminSupplementControllerSearchSupplements,
    adminSupplementControllerGetSupplementById,
    adminSupplementControllerCreateSupplement,
    adminSupplementControllerUpdateSupplement,
    adminSupplementControllerDeleteSupplement,
} from '../api/generated';

// Migrated to the OpenAPI client (GET /admin/supplement -> PageAdminSupplement). The endpoint
// models paging as FLAT page/size (not a nested Spring Pageable), so the SDK serializes them
// correctly. Returns {data} = the PageAdminSupplement body, preserving the old raw-axios
// contract (callers read response.data.content/totalElements). NOTE: `companyId` was dropped
// from the query DTO in the server company-scoping sweep — callers still pass it but it's no
// longer sent (the server derives company from the authed principal), matching every other
// migrated service.
export const searchSupplements = async (params = {}) => {
    try {
        const {data, error} = await adminSupplementControllerSearchSupplements({
            query: {
                page: params.page || 0,
                size: params.size || 20,
                ...(params.keyword && params.keyword.trim() !== '' ? {keyword: params.keyword.trim()} : {}),
            },
        });
        if (error) {
            throw error;
        }
        return {data};
    } catch (error) {
        console.error('Error searching supplements:', error);
        return {
            success: false,
            message: error.response?.data?.message || "שגיאה בחיפוש תוספים",
            data: { content: [], totalElements: 0, totalPages: 0, last: true }
        };
    }
};

// Migrated to the OpenAPI client (GET /admin/supplement/{id} -> AdminSupplement). Old
// returned {success, data: response.data}; SDK `data` is that body (callers read res.data).
export const getSupplementById = async (supplementId) => {
    try {
        const {data, error} = await adminSupplementControllerGetSupplementById({
            path: {id: supplementId},
        });
        if (error) {
            throw error;
        }
        return {
            success: true,
            data
        };
    } catch (error) {
        console.error('Error fetching supplement:', error);
        return {
            success: false,
            message: error.response?.data?.message || "שגיאה בטעינת התוסף",
            data: null
        };
    }
};

// Migrated to the OpenAPI client (POST /admin/supplement -> AdminSupplement). Body is
// CreateSupplementRequest (name/description/imageUrl/purchaseLink); call sites may also
// include `companyId`, which the DTO omits and the server ignores — passed through
// unchanged (the loosely-typed body doesn't error and behavior is identical).
export const createSupplement = async (supplementData) => {
    try {
        const {data, error} = await adminSupplementControllerCreateSupplement({
            body: supplementData,
        });
        if (error) {
            throw error;
        }
        return {
            success: true,
            data,
            message: "התוסף נוצר בהצלחה"
        };
    } catch (error) {
        console.error('Error creating supplement:', error);
        return {
            success: false,
            message: error.response?.data?.message || "שגיאה ביצירת התוסף"
        };
    }
};

// Migrated to the OpenAPI client (PUT /admin/supplement/{id} -> AdminSupplement).
export const updateSupplement = async (supplementId, supplementData) => {
    try {
        const {data, error} = await adminSupplementControllerUpdateSupplement({
            path: {id: supplementId},
            body: supplementData,
        });
        if (error) {
            throw error;
        }
        return {
            success: true,
            data,
            message: "התוסף עודכן בהצלחה"
        };
    } catch (error) {
        console.error('Error updating supplement:', error);
        return {
            success: false,
            message: error.response?.data?.message || "שגיאה בעדכון התוסף"
        };
    }
};

// Migrated to the OpenAPI client (DELETE /admin/supplement/{id}).
export const deleteSupplement = async (supplementId) => {
    try {
        const {data, error} = await adminSupplementControllerDeleteSupplement({
            path: {id: supplementId},
        });
        if (error) {
            throw error;
        }
        return {
            success: true,
            data,
            message: "התוסף נמחק בהצלחה"
        };
    } catch (error) {
        console.error('Error deleting supplement:', error);
        return {
            success: false,
            message: error.response?.data?.message || "שגיאה במחיקת התוסף"
        };
    }
};
